export const SlideData = [
  {
    image:
      "https://s6.uupload.ir/files/158682-smartwatches-review-apple-watch-series-7-all-about-the-screen-image2-ggnlijys37_f4sr.jpg",
    alt: " pic 1",
  },
  {
    image:
      "https://s6.uupload.ir/files/counterpoint-research-global-smartwatch-shipments-jump-35-yoy-in-q1-2021_qlei.jpg",
    alt: " pic 2",
  },
  {
    image: "https://s6.uupload.ir/files/garmin-venu-sq_qw6v.jpg",
    alt: " pic 3",
  },
  {
    image:
      "https://s6.uupload.ir/files/smart-watches-for-women-1605809538_npu9.jpg",
    alt: " pic 4",
  },
];
